import { EasybaseProvider } from 'easybase-react';
import ebconfig from './ebconfig';
import AnmeldeDialog from './AnmeldeDialog';
import FunktionsTabs from './FunktionsTabs';
import { Box, Link, Typography } from '@material-ui/core';

import RehaLogo from './logo/rehasporthermeskeil_eV.jpg';
import SportarenaLogo from './logo/sportarena84_eV.jpg';

const App = (props) => {
  const rehaAdmin = "post@rehasporthermeskeil.de";
  const arenaAdmin = "post@sportarena84.de";
  return (
    <EasybaseProvider ebconfig={ebconfig}>
      <Typography variant="h4">
        Online-Anmeldung
        {props.sr === "r" && (<img src={RehaLogo} alt="REHA-Sport Hermeskeil e.V." width={120} />)}
        {props.sr === "s" && (<img src={SportarenaLogo} alt="Sportarena 84 e.V." width={120} />)}
      </Typography>
      <AnmeldeDialog rehasportName={rehaAdmin} sportarenaName={arenaAdmin}>
        <FunktionsTabs rehasportName={rehaAdmin} sportarenaName={arenaAdmin} sr={props.sr} />
        <br />
      </AnmeldeDialog>
      {props.sr === "s" && (<Box m={1}>
        <Link href="http://sportarena84.de/Impressum.html">Impressum Sportarena 84 e.V.</Link>
      </Box>)}
      {props.sr === "r" && (<Box m={1}>
        <Link href="http://www.rehasporthermeskeil.de/impressum.html">Impressum REHA-Sport Hermeskeil e.V.</Link>
      </Box>)}
      {props.sr === "s" && (<Box m={1}>
        <Link href="http://sportarena84.de">zum Angebot von Sportarena 84 e.V.</Link>
      </Box>)}
      {props.sr === "r" && (<Box m={1}>
        <Link href="http://www.rehasporthermeskeil.de">zum Angebot von REHA-Sport Hermeskeil e.V.</Link>
      </Box>)}
    </EasybaseProvider>
  )
};

export default App;